import { Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import LandingPage from './pages/LandingPage';
import TermsAndConditions from './pages/TermsAndConditions.jsx';
import PolicyPages from './pages/PolicyPages.jsx';
import Service from './pages/Service';
import Sports from './pages/Sports';

import Contact from './pages/Contact';
import About from './pages/About';
import Career from './pages/Career';
import Partners from './pages/Partners';
import MembershipPlans from './pages/Membership';
import GroupFitness from './pages/GroupFitness';
import EventsCalendar from './pages/EventsCalendar';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/service" element={<Service />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PolicyPages />} />
        <Route path="/sports" element={<Sports />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/membership" element={<MembershipPlans />} />
        <Route path="/group-fitness" element={<GroupFitness />} />
        <Route path="/events" element={<EventsCalendar />} />
      </Routes>
    </>
  );
}

export default App;
